import { ref, computed, onUnmounted } from "vue";
// ✅ 單例實例
let deviceInstance = null;
export function useDevice(delay = 0) {
  // delay 0 (即時響應)
  if (deviceInstance) {
    console.log("♻️ 返回現有的 useDevice 實例");
    return deviceInstance;
  }
  // 響應式狀態
  const windowWidth = ref(window.innerWidth);
  const windowHeight = ref(window.innerHeight);
  const screenHeight = ref(Math.min(window.screen.height, window.screen.width));
  const visualViewportHeight = ref(window.visualViewport?.height || 0);

  // 靜態設備信息
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileDevice =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent,
    );
  const isIOS =
    /iphone|ipad|ipod/i.test(userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  const iosVersion = (() => {
    const match = navigator.userAgent.match(/OS (\d+)_(\d+)/);
    if (match) {
      return {
        version: `${parseInt(match[1])}.${parseInt(match[2])}`,
      };
    }
    return null;
  })();

  const isAndroid = /android/.test(userAgent);

  // 計算屬性
  const deviceType = computed(() => {
    if (windowWidth.value <= 576) return "mobile";
    if (windowHeight.value <= 576) return "mobile";
    // if (isMobileDevice) return "mobile";
    return "pc";
  });

  let timeoutId = null;
  // ✅ 更新函數
  const updateSizes = () => {
    windowWidth.value = window.innerWidth;
    windowHeight.value = window.innerHeight;
    screenHeight.value = Math.min(window.screen.height, window.screen.width);
    visualViewportHeight.value = window.visualViewport?.height || 0;
  };
  // ✅ Resize 處理器
  const handleResize = () => {
    if (delay === 0) {
      updateSizes(); // 即時更新
    } else {
      // 防抖更新
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(updateSizes, delay);
    }
  };

  // ✅ 方向變化處理器 - 總是立即響應
  const handleOrientationChange = () => {
    console.log("🔄 設備方向變化");
    updateSizes();
  };
  // ✅ 立即綁定事件監聽器 (不依賴 onMounted)
  if (typeof window !== "undefined") {
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);
    // Visual Viewport API 支援
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleResize);
    }
    console.log("✅ 事件監聽器已綁定");
  }
  // ✅ 清理函數
  const cleanup = () => {
    console.log("🧹 清理 useDevice 事件監聽器");
    if (timeoutId) clearTimeout(timeoutId);
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleResize);
      }
    }
    deviceInstance = null; // 重置單例
  };
  // ✅ 如果在組件上下文中,註冊自動清理
  if (typeof onUnmounted !== "undefined") {
    try {
      onUnmounted(cleanup);
    } catch (e) {
      // 不在組件上下文中,忽略
      console.warn("⚠️ useDevice 在非組件上下文中使用");
    }
  }
  // ✅ 創建並緩存實例
  deviceInstance = {
    windowWidth,
    windowHeight,
    screenHeight,
    visualViewportHeight,
    deviceType,
    isMobileDevice,
    isIOS,
    iosVersion,
    isAndroid,
    isMobile: computed(() => deviceType.value === "mobile"),
    isPc: computed(() => deviceType.value === "pc"),
    cleanup, // 暴露清理函數
  };
  return deviceInstance;
}

// ✅ 導出重置函數 (用於測試或特殊場景)
export function resetDeviceInstance() {
  if (deviceInstance && deviceInstance.cleanup) {
    deviceInstance.cleanup();
  }
  deviceInstance = null;
}
